<template>
    <div class="header" :style="background">
      <div class="content">
        <div class="header-info">
            <h1><slot name="title"></slot></h1>
            <span><slot name="subtitle"></slot></span>
          </div>
      </div>
    </div>
</template>

<style lang="scss">   
@import 'header.scss';
</style>

<script>
export default {
    props: ['background_image'],
    computed: {
        background() {
            return 'background-image: url('+ this.background_image +')';
        }
    }
}

</script>